export enum DocumentType {
  ESOP_PLAN_DOCUMENT = "ESOP_PLAN_DOCUMENT",
  ESOP_BOARD_DOCUMENT = "ESOP_BOARD_DOCUMENT",
  OTHERS = "OTHERS",
  // Grant / Employee / Transaction document types
  GRANT_RELATED_DOCUMENT = "GRANT_RELATED_DOCUMENT",
  EMPLOYEE_RELATED_DOCUMENT = "EMPLOYEE_RELATED_DOCUMENT",
  GRANT_TRANSACTION_DOCUMENT = "GRANT_TRANSACTION_DOCUMENT",
  GRANT_LETTER = "GRANT_LETTER",
  SPLIT_LETTER = "SPLIT_LETTER",
  BONUS_LETTER = "BONUS_LETTER",
}

export interface UploadDocument {
  b64File: string;
  contentType: string;
  documentName: string;
  entityType: DocumentType;
  otherDocumentType?: string;
}

export interface AvailableDocument {
  documentName: string;
  entityType: DocumentType;
  otherDocumentType?: string;
  entityId: string;
  createdAt: string;
  updatedAt: string;
  documentPath: string;
}

export interface DocumentInterface {
  entityId?: string;
  documentPath?: string;
  b64File?: string;
  contentType?: string;
  documentName?: string;
  documentType: DocumentType | string;
  toBeDeleted?: boolean;
  toBeAdded?: boolean;
  isEdited?: boolean;
  id?: string;
  isUserUploaded: boolean;
  metaData?: { shownToEmployee?: boolean; canEmployeeDownload?: boolean };
}

export interface DocumentVault {
  id: string;
  name: string;
  isFolder: boolean;
  children: DocumentVault[];
  url?: string;
  actions?: any;
}
